import * as React from "react";
import {
  createStyles,
  Paper,
  Theme,
  Fab,
  makeStyles,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Chip,
} from "@material-ui/core";
import {
  Add as AddIcon,
  Done as ActiveIcon,
  Announcement as InviteIcon,
} from "@material-ui/icons";
import LoaderRow from "./components/LoaderRow";
import { AnvokError } from "lib";
import { useErrorHandler } from "../ErrorHandler";
import Invite from "./user/Invite";
import { useApiClient } from "lib/store";
import { ApiUser } from "lib/api";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: "100%",
      overflowX: "auto",
    },
    table: {
      minWidth: 700,
    },
    fab: {
      position: "fixed",
      bottom: theme.spacing(2),
      right: theme.spacing(2),
    },
  })
);

const UserList: React.FunctionComponent = () => {
  const api = useApiClient();
  const [loading, setLoading] = React.useState(false);
  const [invite, setInvite] = React.useState(false);
  const [users, setUsers] = React.useState<ApiUser[]>([]);
  const classes = useStyles();
  const errorHandler = useErrorHandler();

  const fetchUsers = React.useCallback(() => {
    setLoading(true);
    api
      .GET("/api/users")
      .then((result) => {
        if (result.error) {
          throw new AnvokError(result.error.message);
        }
        setUsers(result.data.items);
        setLoading(false);
      })
      .catch(errorHandler)
      .finally(() => setLoading(false));
  }, [api, errorHandler]);

  React.useEffect(() => {
    fetchUsers();
  }, [fetchUsers]);

  function handleClose(created: boolean) {
    setInvite(false);
    if (created) {
      fetchUsers();
    }
  }

  return (
    <Paper className={classes.root} elevation={1}>
      <Table className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Nom</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Etat</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <LoaderRow
            show={loading}
            message="Chargement des données..."
            cols={4}
          />
          {users.map((u) => (
            <TableRow key={u._id}>
              <TableCell>{u.name}</TableCell>
              <TableCell>{u.email}</TableCell>
              <TableCell>
                {u.password.length > 0 ? (
                  <Chip
                    size="small"
                    label="Actif"
                    color="primary"
                    icon={<ActiveIcon />}
                  />
                ) : (
                  <Chip
                    size="small"
                    label="Invité"
                    color="secondary"
                    icon={<InviteIcon />}
                  />
                )}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
      <Fab
        color="secondary"
        className={classes.fab}
        onClick={() => setInvite(true)}
      >
        <AddIcon />
      </Fab>
      {invite && <Invite onClose={handleClose} />}
    </Paper>
  );
};

export default UserList;
